import { useAuthenticatedSession } from '@/authenticatedSession/AuthenticatedSessionContext';
import { useFirm } from '@/database/hooks/hooks';
import { isUsingEmulators } from '@/firebaseConfig';
import { useEffect } from 'react';

/**
 * In emulator sessions, default ARAG demo mode on for the seeded Fake Law Firm.
 *
 * Important: only auto-initialize when the flag is currently undefined so users
 * can still toggle it off/on from the Dev Panel without this effect forcing it
 * back on every render.
 */
const FAKE_LAW_FIRM_DOMAIN = 'fakelawfirm.com';

export const AutoEnableAragDemoForMarkEmulator = () => {
  const authSession = useAuthenticatedSession();
  const { firm } = useFirm();

  useEffect(() => {
    if (!isUsingEmulators || !authSession || !firm) {
      return;
    }
    if (firm.domain.toLowerCase() !== FAKE_LAW_FIRM_DOMAIN) {
      return;
    }
    if (firm.demoFlags?.arag !== undefined) {
      return;
    }

    void authSession.db.updateFirm({
      demoFlags: { ...(firm.demoFlags ?? {}), arag: true },
    });
  }, [authSession, firm?.id, firm?.demoFlags?.arag]);

  return null;
};
